import { render, staticRenderFns } from "./estudante-historico-academico-componente.vue?vue&type=template&id=af0076a2&"
import script from "./estudante-historico-academico-componente.vue?vue&type=script&lang=js&"
export * from "./estudante-historico-academico-componente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports